/*
 * Wordmark provisional "DevCore IMJ Media" para la barra lateral abierta.
 * Usa currentColor para heredar el color de la navegación.
 *
 * TODO(ux-ui): sustituir por el logo oficial de IMJ (solicitar SVG a ux-ui).
 */
export const LogoFull = () => (
  <svg
    width="172"
    height="28"
    viewBox="0 0 172 28"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="DevCore IMJ Media"
    fill="currentColor"
  >
    <text
      x="0"
      y="20"
      fontFamily="Inter, Helvetica, Arial, sans-serif"
      fontSize="18"
      fontWeight="700"
      textLength="80"
      lengthAdjust="spacingAndGlyphs"
    >
      DevCore
    </text>
    <text
      x="88"
      y="20"
      fontFamily="Inter, Helvetica, Arial, sans-serif"
      fontSize="18"
      fontWeight="300"
      textLength="84"
      lengthAdjust="spacingAndGlyphs"
    >
      IMJ Media
    </text>
  </svg>
);
